import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import { Subject } from 'rxjs';
import { pairwise, takeUntil } from 'rxjs/operators';
import { SavedItemDropdownAction } from 'Angular/features/components/saved-items/enums/saved-item-dropdown-action.enum';
import { ToastMessageType } from 'Angular/features/components/toast-messages/toast-messages.enum';
import { BaseSavedItemService } from 'Angular/features/components/saved-items/services/common-services/base-saved-item.service';
import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';
import { AppStateManager } from 'Angular/services/app-state-manager.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/app-state-manager.service";
import * as i2 from "Angular/features/components/saved-items/services/common-services/base-saved-item.service";
import * as i3 from "FoldersApp/services/selected-folderable.service";
import * as i4 from "@ngrx/store";
import * as i5 from "Angular/features/components/toast-messages/page-toast-messages-service";
export class FolderableSavedItemDropdownDirective {
    constructor(appStateManagerService, savedItemService, selectedFolderableService, store, toastMessagesService) {
        this.appStateManagerService = appStateManagerService;
        this.savedItemService = savedItemService;
        this.selectedFolderableService = selectedFolderableService;
        this.store = store;
        this.toastMessagesService = toastMessagesService;
        this.state = null;
        this.prevState = null;
        this.prevFolderableItem = null;
        this.ancestorFolderId = null;
        this.unsubscribe = new Subject();
        this.item = null;
    }
    ngOnInit() {
        // Keep component in sync with the selected saved item
        this.selectedFolderableService.selectedFolderable$.pipe(takeUntil(this.unsubscribe)).subscribe((folderable) => {
            if (folderable === null) {
                this.prevState = null;
            }
            else if (this.prevState === null || this.prevFolderableItem?.id !== folderable.item.id) {
                this.prevState = this.appStateManagerService.deserialize(folderable.item.state);
                this.prevFolderableItem = folderable.item;
            }
            this.item = folderable?.item || null;
            this.dropdownOptions = this.getDropdownOptions();
        });
        this.store
            .select('reducers', this.APP_STATE_SLICE_KEY)
            .pipe(takeUntil(this.unsubscribe), pairwise())
            .subscribe(([prev, curr]) => {
            const prevId = prev[this.ITEM_ID_SLICE_KEY];
            const currId = curr[this.ITEM_ID_SLICE_KEY];
            if (prevId !== currId) {
                if (currId === null || currId === undefined) {
                    this.selectedFolderableService.clearSelection();
                }
                else {
                    this.selectedFolderableService.selectFolderable(currId);
                }
            }
        });
        // Keep component in sync with the app state
        this.store
            .select('reducers', this.APP_STATE_SLICE_KEY)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((state) => {
            this.state = this.appStateManagerService.deserialize(state);
            // Since dropdown options are based on `state`, they must be refreshed right after`this.state` is
            // updated. Doing this ensures the options remain consistent with the current state.
            this.dropdownOptions = this.getDropdownOptions();
        });
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    getDropdownOptions() {
        // Clone the base options to preserve dropdown option order.
        const options = cloneDeep(this.BASE_DROPDOWN_OPTIONS);
        return options.map((option) => {
            switch (option.value) {
                case SavedItemDropdownAction.CLOSE:
                    return {
                        ...option,
                        disabled: this.item ? this.item.id === null : true,
                    };
                case SavedItemDropdownAction.SAVE:
                    return {
                        ...option,
                        disabled: this.item ? !(this.itemIsEdited && this.item.permissions.canEdit) : true,
                    };
                case SavedItemDropdownAction.RENAME:
                    return {
                        ...option,
                        disabled: this.item ? !this.item.permissions.canRename : true,
                    };
                case SavedItemDropdownAction.DELETE:
                    return {
                        ...option,
                        disabled: this.item ? !this.item.permissions.canDelete : true,
                    };
                default:
                    return option;
            }
        });
    }
    close() {
        this.selectedFolderableService.clearSelection();
    }
    updateSavedItem() {
        if (this.state === null || this.state[this.ITEM_ID_SLICE_KEY] === null)
            return;
        this.savedItemService.updateItem(this.state[this.ITEM_ID_SLICE_KEY], this.state).subscribe({
            next: () => {
                this.prevState = cloneDeep(this.state);
                this.toastMessagesService.addMessage(`Saved '${this.item?.name}'.`);
                this.dropdownOptions = this.getDropdownOptions();
            },
            error: (errorResponse) => {
                this.toastMessagesService.addMessage(this.savedItemService.getErrorMessage(errorResponse), ToastMessageType.ERROR);
            },
        });
    }
}
FolderableSavedItemDropdownDirective.ɵfac = function FolderableSavedItemDropdownDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableSavedItemDropdownDirective)(i0.ɵɵdirectiveInject(i1.AppStateManager), i0.ɵɵdirectiveInject(i2.BaseSavedItemService), i0.ɵɵdirectiveInject(i3.SelectedFolderableService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.PageToastMessagesService)); };
FolderableSavedItemDropdownDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FolderableSavedItemDropdownDirective });
